"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _placeholderImage = _interopRequireDefault(require("../../placeholder-image"));

var _typography = require("../../typography");

var _socialCard = require("./social-card.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SocialCard = function SocialCard(_ref) {
  var authorHandle = _ref.authorHandle,
      authorName = _ref.authorName,
      authorPhotoUrl = _ref.authorPhotoUrl,
      photoUrl = _ref.photoUrl,
      url = _ref.url,
      backgroundColor = _ref.backgroundColor;

  var placeholder = /*#__PURE__*/_react["default"].createElement(_placeholderImage["default"], {
    src: "".concat(photoUrl, "?q=1&w=250&h=250&fm=jpg"),
    alt: ""
  });

  return /*#__PURE__*/_react["default"].createElement(_socialCard.Wrapper, null, /*#__PURE__*/_react["default"].createElement(_socialCard.LinkWrapper, {
    url: url
  }, /*#__PURE__*/_react["default"].createElement(_socialCard.Image, {
    height: 250,
    quality: 70,
    offset: 500,
    placeholder: placeholder,
    src: "".concat(photoUrl, "?w=250&h=250&fm=jpg"),
    imageProps: {
      draggable: 'false'
    }
  }), /*#__PURE__*/_react["default"].createElement(_socialCard.BottomWrapper, {
    backgroundColor: backgroundColor
  }, /*#__PURE__*/_react["default"].createElement(_socialCard.Avatar, {
    src: "".concat(authorPhotoUrl, "?w=50&h=50&fm=jpg"),
    imageProps: {
      draggable: 'false'
    }
  }), /*#__PURE__*/_react["default"].createElement(_socialCard.TextWrapper, null, /*#__PURE__*/_react["default"].createElement(_typography.Paragraph, null, authorName), /*#__PURE__*/_react["default"].createElement(_typography.Paragraph, null, authorHandle)))));
};

SocialCard.propTypes = {
  authorHandle: _propTypes["default"].string.isRequired,
  authorName: _propTypes["default"].string.isRequired,
  authorPhotoUrl: _propTypes["default"].string.isRequired,
  photoUrl: _propTypes["default"].string.isRequired,
  url: _propTypes["default"].string,
  backgroundColor: _propTypes["default"].string
};
var _default = SocialCard;
exports["default"] = _default;